const nav = $('.nav-fixed');

if (nav.length > 0) {
    import('../lib/PinnedNav').then(({ PinnedNav }) => {
        const mastheadOffset = $('.masthead')[0].getBoundingClientRect().bottom;
        const scrollOffset = $(window).scrollTop();
        const navFixedOffset = mastheadOffset + scrollOffset;

        new PinnedNav(nav, navFixedOffset);

        nav.find('.contextual-navigation-title').on('click', () => {
            nav.toggleClass('is-open');
        });
        nav.find('li a').on('click', () => {
            nav.removeClass('is-open');
        });
    }).catch((error) => console.error(error));
}
